// Prévia de link — o nome da tela de um link da casa (spec de 27/10/2026, §3.3): o cartão de um link do próprio
// SE_WEB não tem site para ler, então mostra o nome da tela para onde ele leva.

const NOME_PADRAO = "SE_WEB";
const NOME_DA_RAIZ = "Início";

/** Prefixo de segmento do caminho -> nome. A ordem aqui é livre: a busca é feita do prefixo mais longo ao mais curto. */
const TELAS: ReadonlyArray<readonly [string, string]> = [
  ["/feed-global", "Feed"],
  ["/feed", "Feed"],
  ["/mensagens", "Chat"],
  ["/drive", "Drive"],
  ["/calendar", "Calendário"],
  ["/central", "Central do Parceiro"],
  ["/atendimentos", "Atendimentos"],
  ["/salas", "Salas"],
  ["/documentos", "Documentos"],
  ["/notificacoes", "Notificações"],
  ["/tasks", "Tarefas"],
  ["/projects", "Projetos"],
  ["/tickets", "Chamados"],
  ["/lojas", "Lojas"],
  ["/terminais", "Terminais de Caixa"],
  ["/metas", "Metas"],
  ["/organograma", "Organograma"],
  ["/rh", "RH"],
  ["/lotese", "Lotese"],
  ["/vpn", "VPN"],
  ["/maquinas", "Máquinas"],
  ["/cofre", "Cofre Técnico"],
  ["/substabelecidos", "Substabelecidos"],
  ["/relatorios", "Relatórios e Dashboards"],
  ["/ajuda", "Ajuda"],
  ["/admin", "Administração"],
  ["/admin/roteiro", "Roteiro"],
  ["/portal", "Portal do Parceiro"],
];

const DO_MAIS_LONGO_AO_MAIS_CURTO = [...TELAS].sort((a, b) => b[0].length - a[0].length);

/**
 * O nome da tela de um caminho da casa (`/feed/posts/9` -> `Feed`). Vale o prefixo de SEGMENTO, e o mais longo
 * vence: `/admin/roteiro` é `Roteiro`, `/admin/usuarios` é `Administração` e `/feedback` não é `/feed`.
 * A consulta (`?`), o fragmento (`#`) e a barra final não contam. Rota que não está na tabela: `SE_WEB`.
 */
export function nomeDaTela(caminho: string): string {
  const semConsulta = caminho.split(/[?#]/, 1)[0].toLowerCase();
  const limpo = semConsulta.replace(/\/+$/, "");
  if (limpo === "") return NOME_DA_RAIZ;
  const achada = DO_MAIS_LONGO_AO_MAIS_CURTO.find(
    ([prefixo]) => limpo === prefixo || limpo.startsWith(`${prefixo}/`)
  );
  return achada ? achada[1] : NOME_PADRAO;
}
